import { Text, View } from '@gluestack-ui/themed'
import { ComponentProps } from 'react'
import { ThemeResult } from '../../api/Theme/types'

export type ThemeState = ThemeResult | null

export enum LoadThemeActionTypes {
  LOAD_THEME = 'LOAD_THEME',
  STORE_THEME = 'STORE_THEME',
}

export type ViewProps = ComponentProps<typeof View>

export type TextProps = ComponentProps<typeof Text>
